import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Confirm } from "@/components/kids/kidsUi";

export function TransferInvite({ hub, onDone }) {
  const [t, setT] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/me/account").then(({ data }) => setT(data.incoming_transfers.find((x) => x.organization_id === hub.id) || null)).catch(() => {}); }, [hub.id]);
  if (!t) return null;
  const accept = () => api.post(`/transfers/${t.id}/accept`).then(({ data }) => {
    toast.success(`You're now the owner of ${t.hub_name}`);
    if (data.subscribe_notice) toast(data.subscribe_notice, { duration: 10000 });
    setT(null); onDone();
    if (data.subscribe_notice) nav(`/h/${hub.id}/family/billing`);
  }).catch((e) => toast.error(errMsg(e)));
  const decline = () => api.post(`/transfers/${t.id}/decline`).then(() => { setT(null); toast("Declined"); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="q-card mb-6 flex flex-wrap items-center gap-3 p-4" style={{ borderColor: "rgba(var(--st-amber4),0.5)" }} data-testid="transfer-invite">
      <Crown className="h-5 w-5 text-amber-300" />
      <p className="min-w-0 flex-1 font-semibold text-q-text" data-testid="transfer-invite-text">{t.from_name.split(" ")[0]} wants to make you the owner of {t.hub_name}.</p>
      <button className="q-btn q-btn-primary min-h-[44px]" onClick={accept} data-testid="transfer-accept-btn">Accept</button>
      <button className="q-btn q-btn-ghost min-h-[44px]" onClick={decline} data-testid="transfer-decline-btn">Decline</button>
    </div>
  );
}

export function TransferButton({ hub, m }) {
  const [open, setOpen] = useState(false);
  const go = () => api.post(`/organizations/${hub.id}/transfer`, { to_user_id: m.user_id })
    .then(() => { toast.success(`Asked ${m.name.split(" ")[0]} to accept`); setOpen(false); }).catch((e) => toast.error(errMsg(e)));
  return (
    <>
      <button className="q-btn q-btn-ghost min-h-[44px] px-2.5 text-xs" onClick={() => setOpen(true)} data-testid={`transfer-btn-${m.user_id}`}><Crown className="h-3.5 w-3.5" /> Make owner</button>
      <Confirm open={open} onClose={() => setOpen(false)} title={`Make ${m.name} the owner?`} confirmLabel="Send request"
        body={`${m.name.split(" ")[0]} must accept. You'll become a co-parent. If there's an active plan, it ends at the end of the current period, and ${m.name.split(" ")[0]} can manage the plan from The Queue on the web. Gifted or comped time stays with the family.`}
        onConfirm={go} testid="transfer-confirm" />
    </>
  );
}
